import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading = new Subject<boolean>();
  isLoad = new Subject<boolean>();
  ad = new Subject<boolean>();

  constructor(){
    this.isLoading.next(true);
    this.isLoad.next(true);
    this.ad.next(false);
  }
    show() {
        this.isLoading.next(true);
    }
    hide() {
        this.isLoading.next(false);
    }

    adshow() {
      this.ad.next(true);
  }
  adhide() {
      this.ad.next(false);
  }

    load(){
      this.isLoad.next(true);
    }

    unload(){
      this.isLoad.next(false);
    }

}
